export default __webpack_public_path__ + "static/media/M1-male-01_mos.7ba3af31.wav";